import { render, staticRenderFns } from "./cctest.vue?vue&type=template&id=b2c072ea&scoped=true&"
import script from "./cctest.vue?vue&type=script&lang=js&"
export * from "./cctest.vue?vue&type=script&lang=js&"
import style0 from "./cctest.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cctest.vue?vue&type=style&index=1&id=b2c072ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c072ea",
  null
  
)

export default component.exports